import React, { useContext } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { MBBoxedIcon, MBImageURISource } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { ColorThemeContext } from '@shared/styles';

export interface MBIconButtonProps {
  source: MBImageURISource;
  size?: 'small' | 'normal';
  color?: string;
  backgroundColor?: string;
  inverted?: boolean;
  style?: StyleProp<ViewStyle>;
  onPress?: (node: React.Component) => any;
  testID?: string;
}

export function MBIconButton({
  source,
  inverted,
  onPress,
  size = 'normal',
  color: overrideColor,
  style,
  backgroundColor: overrideBackgroundColor,
  testID,
}: MBIconButtonProps) {
  const colors = useContext(ColorThemeContext);
  const color = !!overrideColor
    ? overrideColor
    : inverted
    ? colors.button.foregroundInverted
    : colors.button.foreground;
  const backgroundColor = !!overrideBackgroundColor
    ? overrideBackgroundColor
    : inverted
    ? colors.button.backgroundInverted
    : colors.button.background;
  return (
    <MBTouchableOpacity disabled={!onPress} onPress={onPress} testID={testID}>
      <MBBoxedIcon
        size={size}
        source={source}
        color={color}
        backgroundColor={backgroundColor}
        style={style}
      />
    </MBTouchableOpacity>
  );
}
